import Layout from 'components/layout/Layout';
import { ProfilePageWrapper } from 'components/layout/ProfilPageWrapper';
import { useEffect } from 'react';
import { useRouter } from 'next/router';
import { MON_PROFIL_PATH } from 'lib/paths';

const MonComptePage = () => {
  const { push } = useRouter();

  useEffect(() => {
    push(MON_PROFIL_PATH);
  }, []);

  return null;
};

MonComptePage.getWrappers = (page) => (
  <Layout variant="adaptative" rowVariant="gray" containerWidth="lg">
    <ProfilePageWrapper>{page}</ProfilePageWrapper>
  </Layout>
);

export default MonComptePage;
